import React, { useState, useEffect } from 'react';
import { MessageCircle, X, Instagram } from 'lucide-react';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(true);

  const whatsappNumber = "5585985195369";
  const whatsappMessage = "Olá! Gostaria de mais informações sobre os serviços.";
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;
  const instagramLink = "https://www.instagram.com/infortech_graficaeassistencia";

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // Hide tooltip after 5 seconds
    const timer = setTimeout(() => {
      setShowTooltip(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* Floating WhatsApp Button */}
      <div 
        className={`fixed bottom-6 right-6 z-50 flex flex-col gap-3 transition-all duration-300 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-16'
        }`}
      >
        {/* Tooltip */}
        {showTooltip && (
          <div className="absolute bottom-full right-0 mb-3 mr-2 animate-bounce">
            <div className="relative bg-white rounded-lg shadow-xl p-3 pr-10 max-w-[200px] border-2 border-[#25D366]">
              <p className="text-sm font-medium text-gray-800">
                Precisa de ajuda? Fale conosco!
              </p>
              <button
                onClick={() => setShowTooltip(false)}
                className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
              >
                <X className="w-4 h-4" />
              </button>
              {/* Arrow */}
              <div className="absolute -bottom-2 right-6 w-4 h-4 bg-white border-r-2 border-b-2 border-[#25D366] transform rotate-45"></div>
            </div>
          </div>
        )}

        {/* Instagram Button */}
        <a
          href={instagramLink}
          target="_blank"
          rel="noopener noreferrer"
          className="group relative flex items-center justify-center w-14 h-14 bg-gradient-to-br from-[#F58529] via-[#DD2A7B] to-[#8134AF] hover:from-[#F77737] hover:via-[#E23B86] hover:to-[#8A3FBA] rounded-full shadow-2xl hover:shadow-pink-500/50 transition-all duration-300 hover:scale-110"
        >
          <Instagram className="relative w-7 h-7 text-white" />
        </a>

        {/* WhatsApp Button */}
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="group relative flex items-center justify-center w-16 h-16 bg-[#25D366] hover:bg-[#20BD5C] rounded-full shadow-2xl hover:shadow-[#25D366]/50 transition-all duration-300 hover:scale-110"
          onClick={() => setShowTooltip(false)}
        >
          {/* Pulse Animation */}
          <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-75 animate-ping"></span>
          
          {/* Icon */}
          <MessageCircle className="relative w-8 h-8 text-white" />
          
          {/* Notification Badge */}
          <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center">
            <span className="text-white text-xs font-bold">1</span>
          </span>
        </a>
      </div>
    </>
  );
};

export default WhatsAppButton;
